import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import classnames from 'classnames';
import close from 'images/cancel.svg';
import searchIcon from 'images/search.svg';
import fbIcon from 'images/facebook_gray.svg';
import igIcon from 'images/instagram_gray.svg';

import Button from 'components/atoms/Button';
import { toggleNavi } from 'actions/global';
import { logout } from 'actions/auth';

import styles from './index.css';

/*

<li role="presentation" onClick={() => onToggle(false)}>
	<Link to="/reserve">
		<span>預約諮詢</span>
	</Link>
</li>
*/

const Navigator = ({
	naviToggle,
	onToggle,
	authorized,
	onLogout,
	name,
	credit,
}) => (
	<nav className={classnames(styles.navi, {
		[styles.toggle]: naviToggle,
	})}
	>
		<div className={styles.mobileNavTop}>
			<div className={styles.search}>
				<input type="text" />
				<span><img src={searchIcon} alt="" /></span>
			</div>
			<button className={styles.close} onClick={() => onToggle(false)}>
				<img src={close} alt="" />
			</button>
		</div>
		<ul className={styles.ul}>
			<li>
				<a href="http://www.yuanyu.tw/camera/news.php">
					<span>最新消息</span>
					<span className={styles.nav_en}>NEWS</span>
				</a>
			</li>
			<li>
				<a href="http://www.yuanyu.tw/camera/about.php">
					<span>企業情報</span>
					<span className={styles.nav_en}>ABOUT US</span>
				</a>
			</li>
			<li>
				<a href="http://www.yuanyu.tw/camera/product">
					<span>產品情報</span>
					<span className={styles.nav_en}>PRODUCT</span>
				</a>
			</li>
			<li>
				<span>銷售據點</span>
				<span className={styles.nav_en}>SHOPS</span>
				<ul className={styles.navList}>
					<li role="presentation" onClick={() => onToggle(false)}>
						<a href="http://www.yuanyu.tw/camera/store.php">
							<span>地圖搜尋</span>
						</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/store-list.php">
							<span>商家清單</span>
						</a>
					</li>
				</ul>
			</li>
			<li role="presentation" onClick={() => onToggle(false)}>
				<Link to="/course">
					<span>課程資訊</span>
					<span className={styles.nav_en}>EVENT</span>
				</Link>
			</li>
			<li>
				<a href="http://www.yuanyu.tw/camera/gallery.php">
					<span>線上藝廊</span>
					<span className={styles.nav_en}>GALLERY</span>
				</a>
			</li>
			<li>
				<span>客戶服務</span>
				<span className={styles.nav_en}>SERVICE</span>
				<ul className={styles.navList}>
					<li role="presentation" onClick={() => onToggle(false)}>
						<a href="http://www.yuanyu.tw/camera/service-warranty-information.php">
							<span>保固說明</span>
						</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/service-product-registration.php">
							<span>產品註冊</span>
						</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/service-announcements.php">
							<span>維修服務</span>
						</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/service-repair-status.php">
							<span>維修進度查詢</span>
						</a>
					</li>
					<li>
						<a href="http://www.yuanyu.tw/camera/service-center.php">
							<span>客服展售中心</span>
						</a>
					</li>
				</ul>
			</li>
			<li>
				<a href="https://www.yuanyu.tw/camera/blog/" target="_blank" rel="noopener noreferrer">
					<span>官方部落格</span>
					<span className={styles.nav_en}>BLOG</span>
				</a>
			</li>
			<li>
				<a href="https://shop.yuanyu.tw/" target="_blank" rel="noopener noreferrer">
					<span>線上購物</span>
					<span className={styles.nav_en}>SHOP ONLINE</span>
				</a>
			</li>
			<li>
				<span>會員專區</span>
				<span className={styles.nav_en}>MEMBER</span>
				<ul className={styles.navList}>
					<li role="presentation" onClick={() => onToggle(false)}>
						<Link to="/member">
							<span>個人資料</span>
						</Link>
					</li>
					<li role="presentation" onClick={() => onToggle(false)}>
						<Link to="/product">
							<span>商品履歷</span>
						</Link>
					</li>
					<li role="presentation" onClick={() => onToggle(false)}>
						<Link to="/coupon">
							<span>課程優惠</span>
						</Link>
					</li>
					<li role="presentation" onClick={() => onToggle(false)}>
						<Link to="/membercourse">
							<span>課程履歷</span>
						</Link>
					</li>
					<li role="presentation" onClick={() => onToggle(false)}>
						<Link to="/reserve">
							<span>預約諮詢</span>
						</Link>
					</li>
					<li role="presentation" onClick={() => onToggle(false)}>
						<Link to="/event">
							<span>回函禮</span>
						</Link>
					</li>
				</ul>
			</li>
		</ul>
		<div className={styles.mobileNavBottom}>
			<a href="https://www.facebook.com/OlympusTW/" target="_blank" rel="noopener noreferrer">
				<img src={fbIcon} alt="" />
				<span className={styles.sub}>Facebook</span>
			</a>
			<a href="https://www.instagram.com/olympus.tw/?hl=zh-tw" target="_blank" rel="noopener noreferrer">
				<img src={igIcon} alt="" />
				<span className={styles.sub}>Instagram</span>
			</a>
			<div style={{
				backgroundColor: '#444444',
				overflow: 'hidden',
				position: 'relative',
				left: '-15px',
				padding: '8px 15px',
			}}
			>
				{
					authorized === true ?
						<span role="presentation" onClick={() => onToggle(false)}>
							<Link to="/member"> 嗨，{name} /</Link>
							<a
								href={process.env.NODE_ENV === 'production' ? 'https://shop.yuanyu.tw/user/bonus' : 'https://shop-yuanyu.25demo.com/user/bonus'}
								style={{ color: '#f8bf31', margin: '0', fontSize: '12px' }}
							>
								目前紅利：{credit} 點
							</a>
							<Button color="link" onClick={onLogout}>登出</Button>
						</span>
						:
						<span>
							<Link to="/login"> 登入 /</Link>
							<Link to="/signup"> 註冊</Link>
						</span>
				}
			</div>
		</div>
	</nav>
);

function mapStateToProps({
	global: { naviToggle },
	auth: { token: { accessToken } },
	members: { name, credit },
}) {
	return {
		authorized: accessToken !== '',
		naviToggle,
		name,
		credit,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		onToggle: toggle => dispatch(toggleNavi(toggle)),
		onLogout: () => dispatch(logout()),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Navigator);



// WEBPACK FOOTER //
// ./src/components/molecules/Navigation/index.js